import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {EditorModule} from "primeng/editor";
import {PrimeTemplate} from "primeng/api";
import {PrimeNgModule} from "../../prime-ng/prime-ng.module";
import {EvaluacionEstadosControl} from "../../../officials/evaluaciones/interfaces/evaluaciones.interface";

@Component({
  selector: 'app-editor-text',
  standalone: true,
    imports: [
        EditorModule,
        PrimeTemplate,
        PrimeNgModule
    ],
  templateUrl: './editor-text.component.html',
  styleUrl: './editor-text.component.scss'
})
export class EditorTextComponent {
    @Input()text: string = '';
    @Input()textReadOnly: boolean = false;
    @Input() type: number=0;
    @Output() onEventEmitterText = new EventEmitter<string>;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    private quillEditor: any;
    textChangeEditor: WritableSignal<string> = signal('');
    protected readonly EvaluacionEstadosControl = EvaluacionEstadosControl;
    constructor() {
    }
    emitTextChange() {
        this.textChangeEditor.set(this.text)
        this.onEventEmitterText.emit(this.textChangeEditor());
    }

    onEditorInit(event: any) {
        this.quillEditor = event.editor;

        const toolbar = this.quillEditor.getModule('toolbar');
        toolbar.addHandler('image', () => {
            this.fileInput.nativeElement.click();
        });

        this.quillEditor.on('text-change', () => {
            const contenidoEditor = this.quillEditor.root.innerHTML;
            // detectar si está vacío realmente
            const estaVacio = contenidoEditor === '<p><br></p>' || this.quillEditor.getText().trim() === '';
            this.textChangeEditor.set(contenidoEditor);
            this.onEventEmitterText.emit(this.textChangeEditor());
            if (estaVacio) {
                console.log('editor vacío');
            }
        });
    }

    onImagenSeleccionada(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result as string;
                const range = this.quillEditor.getSelection(true);
                this.quillEditor.insertEmbed(range.index, 'image', base64);
                this.quillEditor.setSelection(range.index + 1);
                this.text = this.quillEditor.root.innerHTML;
                this.textChangeEditor.set(this.quillEditor.root.innerHTML)
                this.onEventEmitterText.emit(this.textChangeEditor());
            };

            reader.readAsDataURL(file);
            input.value = '';
        }
    }

    getTooltipText(): string {
        if (this.type === EvaluacionEstadosControl.Observaciones) {
            return this.textReadOnly ? '':'Toda Lla información que se escriba o inserte en este apartado, incluidas las imágenes, se notificará tal cual como se ingrese';
        } else if (this.type === EvaluacionEstadosControl.Dictamen) {
            return this.textReadOnly ? '' : 'Toda la información que se escriba o inserte en este apartado, se guardará tal cual como se ingrese';
        }
        return '';
    }
}
